import { AfterViewInit, Component, ElementRef, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { ContentPath } from '../content-header/content-path';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.less'],
  standalone: false
})
export class AdminLayoutComponent implements OnInit, AfterViewInit, OnDestroy {

  navbarOk: boolean = false;
  contentOk: boolean = false;
  sidebarOk: boolean = false;
  footerOk: boolean = false;
  private resizeObserver?: ResizeObserver;
  private routerSubscription?: any;
  private readonly SIDEBAR_STATE_KEY = 'smo_sidebar_state';

  @Input()
  title: string = '';

  @Input()
  subtitle: string = '';

  @Input()
  contentsPath: ContentPath[] = [];

  @Input()
  contentId: string = '';

  @Input()
  showContentHeader: boolean = true;

  constructor(
    public authService: AuthService,
    public el: ElementRef,
    private router: Router
  ) { }

  onNavbarOk(): void {
    this.navbarOk = true;

    this.rebindEvents();
  }

  onSidebarOk(): void {
    this.sidebarOk = true;

    this.rebindEvents();
  }

  onFooterOk(): void {
    this.footerOk = true;

    this.rebindEvents();
  }

  ngOnInit() {
    // Clean up styles on navigation start (before new component loads)
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        // Remove old styles before navigation
        this.cleanupContentStyles();
      } else if (event instanceof NavigationEnd) {
        // Recalculate after new component is loaded
        setTimeout(() => {
          this.adjustContentHeight();
        }, 250);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    ($('body') as any).off('.adminLayout');
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.adjustContentHeight();
  }

  ngAfterViewInit(): void {
    this.contentOk = true;

    this.rebindEvents();
    this.adjustContentHeight();

    // Observe content wrapper for size changes
    const contentWrapper = this.el.nativeElement.querySelector('.content-wrapper');
    if (contentWrapper) {
      this.resizeObserver = new ResizeObserver(() => {
        this.adjustContentHeight();
      });
      this.resizeObserver.observe(contentWrapper);
    }
  }

  cleanupContentStyles(): void {
    const mainContent = this.el.nativeElement.querySelector('.content');

    if (mainContent) {
      // Clean up main content styles
      mainContent.style.removeProperty('display');
      mainContent.style.removeProperty('flex-direction');
      mainContent.style.removeProperty('min-height');

      // Clean up all children styles
      Array.from(mainContent.children).forEach((child: any) => {
        if (child.tagName.toLowerCase() !== 'router-outlet') {
          child.style.removeProperty('flex');
          child.style.removeProperty('display');
          child.style.removeProperty('flex-direction');
          child.style.removeProperty('min-height');
        }
      });

      //console.log('✓ Cleaned up content styles before navigation');
    }
  }

  adjustContentHeight(): void {
    return; // Disabled...
    
    setTimeout(() => {
      const contentWrapper = this.el.nativeElement.querySelector('.content-wrapper');
      const contentHeader = this.el.nativeElement.querySelector('.system-content-header');
      const mainContent = this.el.nativeElement.querySelector('.content');

      /*console.log('Adjusting content height...', {
        contentWrapper: !!contentWrapper,
        contentHeader: !!contentHeader,
        mainContent: !!mainContent
      });*/

      if (contentWrapper && mainContent) {
        // Get wrapper height
        const wrapperHeight = contentWrapper.clientHeight;

        if (wrapperHeight === 0) {
          console.warn('Content wrapper height is 0, skipping adjustment');
          return;
        }

        // Get header height (0 if hidden or not present)
        const headerHeight = contentHeader && contentHeader.offsetHeight > 0 ? contentHeader.offsetHeight : 0;

        // Calculate available height for content
        const availableHeight = wrapperHeight - headerHeight;

        //console.log('Height calculation:', {
        //  wrapperHeight,
        //  headerHeight,
        //  availableHeight
        //});

        if (availableHeight > 0) {
          // ALWAYS force content to be flex container
          mainContent.style.setProperty('display', 'flex', 'important');
          mainContent.style.setProperty('flex-direction', 'column', 'important');
          mainContent.style.setProperty('min-height', `${availableHeight}px`, 'important');

          // ALWAYS force router outlet content to fill available height
          const routerOutletContent = Array.from(mainContent.children).find(
            (child: any) => child.tagName.toLowerCase() !== 'router-outlet'
          ) as HTMLElement;

          if (routerOutletContent) {
            routerOutletContent.style.setProperty('flex', '1 0 auto', 'important');
            routerOutletContent.style.setProperty('display', 'flex', 'important');
            routerOutletContent.style.setProperty('flex-direction', 'column', 'important');
            routerOutletContent.style.setProperty('min-height', '100%', 'important');
            //console.log('✓ Router outlet content forced to fill height');
          }

          //console.log(`✓ Content min-height set to: ${availableHeight}px`);
        }
      } else {
        //console.warn('Could not find required elements for height adjustment');
      }
    }, 200);
  }

  rebindEvents(): void {
    if (this.contentOk) {
      if (this.navbarOk && this.sidebarOk && this.footerOk) {
        this.navbarOk = false;
        this.sidebarOk = false;
        this.footerOk = false;

        /*
         * routerLinkActive ainda nao seto a classe ainda no ngAfterViewInit
         * por isso do settimeout.
         */
        setTimeout(() => {
          //console.log('Rebind Admin Layout Events');

          $('[data-widget="tree"]').each(function () {
            ($(this) as any).tree();
          });

          ($('body') as any).layout();

          this.bindSidebarState();

          // Adjust content height after layout is applied
          this.adjustContentHeight();
        }, 0);
      }
    }
  }

  private bindSidebarState(): void {
    const saved = localStorage.getItem(this.SIDEBAR_STATE_KEY);

    if (saved === 'expanded') {
      $('body').removeClass('sidebar-collapse');
    } else {
      // Default: sidebar colapsada
      $('body').addClass('sidebar-collapse');
    }

    // Remove listeners anteriores para evitar duplicatas
    ($('body') as any).off('expanded.pushMenu.adminLayout collapsed.pushMenu.adminLayout');

    ($('body') as any).on('expanded.pushMenu.adminLayout', () => {
      localStorage.setItem(this.SIDEBAR_STATE_KEY, 'expanded');
    });

    ($('body') as any).on('collapsed.pushMenu.adminLayout', () => {
      localStorage.setItem(this.SIDEBAR_STATE_KEY, 'collapsed');
    });
  }

}
